import {useParams} from "react-router";
import {fr} from "./i18n/DetailsCompteEpargneStable.i18n.fr";
import {en} from "./i18n/DetailsCompteEpargneStable.i18n.en";
import {useEffect} from "react";
import {LangueUtils} from "@oel/js-i18n";
import {ConfigurationService} from "@oel/js-configuration";
import {GabaritNavigationUtil} from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import {IdPageEnum} from "../../../utils/gabarit-navigation/IdPageEnum";
import * as bc from "bc-js";


export function DetailsCompteEpargneStable() {

    const params = useParams();
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = ConfigurationService.getConfig("oel-is-app") === "false" ? libelles.titreOnglet : libelles.titreOngletMobile;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.DETAIL_ES_ADA);
        bc.changerContexte("ACCOUNT_Detail");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <detail-compte-bancaire id-contexte={params.idContexte}/>
        </div>
    );
}
